const PlayIcon = (props: React.ComponentPropsWithoutRef<'svg'>) => (
  <svg
    width="512"
    height="512"
    viewBox="0 0 512 512"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_346016_6455)">
      <path
        d="M256 512C397.385 512 512 397.385 512 256C512 114.615 397.385 0 256 0C114.615 0 0 114.615 0 256C0 397.385 114.615 512 256 512Z"
        fill="black"
        fillOpacity="0.5"
      />
      <path
        d="M181 376V136C181 124.02 194.352 116.874 204.32 123.519L384.32 243.519C393.226 249.456 393.226 262.543 384.32 268.481L204.32 388.481C194.352 395.126 181 387.981 181 376Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_346016_6455">
        <rect width="512" height="512" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default PlayIcon
